import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Typography, Paper, Box, LinearProgress, Button } from '@mui/material';
import styled from 'styled-components';
import './Home.css';

const fetchAllData = async () => {
  const API_URL = '/api/';
  const endpoints = [
    'convidados', 'fotografo', 'comida', 'decoracao', 'lembrancinha', 'caixas_convite',
    'cerimonialista', 'cha_panela', 'cha_panela_desejos', 'vestido_noiva',
    'espaco_recepcao', 'daminha_pajem', 'curso_noivos', 'igreja'
  ];
  const results = {};
  for (const ep of endpoints) {
    const res = await axios.get(`${API_URL}${ep}`);
    results[ep] = res.data;
  }
  return results;
};

const getConvidadosPorNoivo = (convidados) => {
  const counts = {
    Graziele: { total: 0, confirmados: 0 },
    Fernando: { total: 0, confirmados: 0 }
  };
  if (!Array.isArray(convidados)) return counts;
  convidados.forEach(c => {
    if (c && typeof c.noivo === 'string') {
      if (c.noivo.toLowerCase() === 'graziele') {
        counts.Graziele.total++;
        if (c.confirmado) counts.Graziele.confirmados++;
      } else if (c.noivo.toLowerCase() === 'fernando') {
        counts.Fernando.total++;
        if (c.confirmado) counts.Fernando.confirmados++;
      }
    }
  });
  return counts;
};

function formatReal(value) {
  if (value === '' || value === undefined) return '';
  let num = value;
  if (typeof num === 'string') {
    num = num.replace(/\D/g, '');
    if (num === '') return '';
    num = parseFloat(num);
  }
  return (num / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

const Table = styled.table`
  width: 100%;
  max-width: 500px;
  margin: 1rem auto;
  border-collapse: collapse;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(109, 36, 21, 0.1);
`;

const Td = styled.td`
  padding: 0.75rem;
  border-bottom: 1px solid #eee;
`;

const Home = ({ setPage, isAdmin = true }) => {
  const [data, setData] = useState(null);
  const orcamentoTotal = 20000;
  const [loading, setLoading] = useState(true);
  const weddingDate = new Date('2026-07-18T00:00:00');
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0, isFinished: false });
  const [bgIndex, setBgIndex] = useState(0);
  const [convidadosCount, setConvidadosCount] = useState({ total: 0, confirmados: 0, presentes: 0 });
  const bgImages = [
    '/media/20250531_152259.jpg',
    '/media/20250419_202531.jpg',
    '/media/20250302_093752.jpg',
    '/media/20250222_202834.jpg',
    '/media/Imagem do WhatsApp de 2025-07-27 à(s) 18.03.19_6a05dd4e.jpg',
    '/media/Imagem do WhatsApp de 2025-06-01 à(s) 16.48.29_d3833c7e.jpg',
    '/media/Imagem do WhatsApp de 2025-06-01 à(s) 16.48.22_79dd52eb.jpg',
  ];

  const [totais, setTotais] = useState({
    valor_total: 0,
    valor_parcelas: 0,
    valor_parcelas_pagas: 0,
    valor_parcelas_nao_pagas: 0
  });

  useEffect(() => {
    (async () => {
      const d = await fetchAllData();
      setData(d);
      setLoading(false);
    })();

    const fetchOrcamento = async () => {
      const despesasRes = await axios.get('/api/despesas');
      const despesas = despesasRes.data;

      let valor_total = 0, valor_parcelas = 0, valor_parcelas_pagas = 0, valor_parcelas_nao_pagas = 0;

      for (const d of despesas) {
        valor_total += Number(d.valor_total);
        const parcelasRes = await axios.get(`/api/parcelas/${d.id}`);
        const parcelas = parcelasRes.data;
        parcelas.forEach(p => {
          valor_parcelas += Number(p.valor);
          if (p.paga) {
            valor_parcelas_pagas += Number(p.valor);
          } else {
            valor_parcelas_nao_pagas += Number(p.valor);
          }
        });
      }
      setTotais({ valor_total, valor_parcelas, valor_parcelas_pagas, valor_parcelas_nao_pagas });
    };

    const fetchConvidadosCount = async () => {
      const res = await axios.get('/api/convidados/contagem');
      setConvidadosCount({
        total: res.data.total || 0,
        confirmados: res.data.confirmados || 0,
        presentes: res.data.presentes || 0,
      });
    }

    fetchOrcamento();
    fetchConvidadosCount();
    const interval = window.setInterval(() => {
      fetchConvidadosCount();
    }, 5000);
    return () => window.clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!weddingDate) return;
    const interval = setInterval(() => {
      const now = new Date();
      const diff = weddingDate - now;
      if (diff > 0) {
        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);
        setCountdown({ days, hours, minutes, seconds, isFinished: false });
      } else {
        setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0, isFinished: true });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [weddingDate]);

  useEffect(() => {
    const interval = setInterval(() => {
      setBgIndex(i => (i + 1) % bgImages.length);
    }, 20000);
    return () => clearInterval(interval);
  }, []);

  if (loading || !data) return <LinearProgress sx={{ mt: 4 }} />;

  const bgStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1,
    background: `url('${bgImages[bgIndex]}') center/cover no-repeat fixed`,
    opacity: 0.18,
    transition: 'background-image 2s',
  };

  const convidadosPorNoivo = getConvidadosPorNoivo(data.convidados);

  return (
    <>
      <div style={bgStyle}></div>
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ fontFamily: 'Great Vibes, Parisienne, cursive', fontSize: { xs: 32, md: 48 }, textAlign: 'center' }}>
          Organização do Casamento Graziele e Fernando
        </Typography>
        {weddingDate && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 3 }}>
            <Paper
              sx={{
                p: 2,
                bgcolor: countdown.isFinished ? 'rgba(255, 235, 238, 0.95)' : 'rgba(255,255,255,0.85)',
                borderRadius: 3,
                boxShadow: countdown.isFinished ? 6 : 3,
                border: countdown.isFinished ? '2px solid #d32f2f' : 'none',
                animation: countdown.isFinished ? 'pulse 1.2s infinite' : 'none',
                '@keyframes pulse': {
                  '0%': { transform: 'scale(1)' },
                  '50%': { transform: 'scale(1.02)' },
                  '100%': { transform: 'scale(1)' },
                },
              }}
            >
              <Typography variant="h6" align="center" sx={{ fontFamily: 'Parisienne, Great Vibes, cursive', fontSize: 28, mb: 1, color: countdown.isFinished ? '#b71c1c' : 'inherit' }}>
                {countdown.isFinished ? 'E chegou o grande dia!' : 'Contagem Regressiva para o Grande Dia'}
              </Typography>
              {countdown.isFinished ? (
                <Typography align="center" sx={{ fontWeight: 700, fontSize: 22, color: '#b71c1c' }}>
                  Que emoção! Hoje é o dia tão aguardado 💕
                </Typography>
              ) : (
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', fontSize: 22 }}>
                  <span><b>{countdown.days}</b> dias</span>
                  <span><b>{countdown.hours}</b>h</span>
                  <span><b>{countdown.minutes}</b>m</span>
                  <span><b>{countdown.seconds}</b>s</span>
                </Box>
              )}
            </Paper>
          </Box>
        )}
        <Paper
          sx={{ p: 3, mb: 3, cursor: 'pointer', transition: 'transform 0.2s ease, box-shadow 0.2s ease', '&:hover': { transform: 'translateY(-2px)', boxShadow: 4 } }}
          onClick={() => setPage('convidados')}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
            <Typography variant="h6">Convidados</Typography>
            <Button size="small" variant="outlined" onClick={(e) => { e.stopPropagation(); setPage('convidados'); }}>Ver lista</Button>
          </Box>
          <Typography>Graziele: {convidadosPorNoivo.Graziele.confirmados} de {convidadosPorNoivo.Graziele.total}</Typography>
          <Typography>Fernando: {convidadosPorNoivo.Fernando.confirmados} de {convidadosPorNoivo.Fernando.total}</Typography>
          <Typography>Confirmados: {convidadosCount.confirmados} de {convidadosCount.total}</Typography>
          <Typography>Presentes: {convidadosCount.presentes} de {convidadosCount.total}</Typography>
        </Paper>
        {isAdmin && (
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6">Orçamento</Typography>
            <Table>
              <tbody>
                <tr>
                  <Td>Valor Total</Td>
                  <Td>{formatReal(totais.valor_total)}</Td>
                </tr>
                <tr>
                  <Td>Valor Parcelas</Td>
                  <Td>{formatReal(totais.valor_parcelas)}</Td>
                </tr>
                <tr>
                  <Td>Parcelas Pagas</Td>
                  <Td>{formatReal(totais.valor_parcelas_pagas)}</Td>
                </tr>
                <tr>
                  <Td>Parcelas Não Pagas</Td>
                  <Td>{formatReal(totais.valor_parcelas_nao_pagas)}</Td>
                </tr>
              </tbody>
            </Table>
            <LinearProgress variant="determinate" value={Math.min(100, (totais.valor_total / orcamentoTotal) * 100)} sx={{ height: 10, borderRadius: 5 }} />
          </Paper>
        )}
      </Container>
    </>
  );
};


export default Home;